import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { EnquiriesService } from './../../services/enquiries.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { FileSection, FileType } from '../../models/fileData';
import { FileService } from './../../services/file.service';
import { ToastService } from './../../services/toast.service';

declare var $: any;

@Component({
  selector: 'app-media-enquiries',
  templateUrl: './media-enquiries.component.html'
})
export class MediaEnquiriesComponent implements OnInit {

  EnquiryData$: FormGroup;

  ResultMessage$: string = "";

  submitted: boolean = false;
  pageErrors: boolean = false;

  uploadedFiles: any[];

  captchaInvalid: boolean = true;

  constructor(
    private datePipe: DatePipe,
    private enquiriesService: EnquiriesService,
    private formBuilder: FormBuilder,
    public toastService: ToastService,
    private fileService: FileService) { }

  resolved(captchaResponse: string) {

    if (captchaResponse == null) {
      this.captchaInvalid = true;
    }
    else {
      this.captchaInvalid = false;
    }
  }

  get f() { return this.EnquiryData$.controls; }

  sendEnquiry() {

    this.ResultMessage$ = "Submitting, please wait...";

    this.submitted = true;
    this.pageErrors = false;

    if (this.EnquiryData$.invalid) {
      this.pageErrors = true;
      this.ResultMessage$ = 'One or more fields are invalid.';
      return;
    }

    if (this.captchaInvalid == true) {
      this.pageErrors = true;
      this.ResultMessage$ = "Please complete the captcha";
      return;
    }

    var currentDate = new Date(this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS'));

    let enquiry = {
      "id": 0,
      "sectionId": 1,
      "dateAdded": currentDate,
      "enquiryProperties": []
    };

    enquiry.enquiryProperties.push({ "key": "mediaHouse", "value": this.EnquiryData$.controls.mediaHouse.value });
    enquiry.enquiryProperties.push({ "key": "fullName", "value": this.EnquiryData$.controls.fullName.value });
    enquiry.enquiryProperties.push({ "key": "postion", "value": this.EnquiryData$.controls.position.value });
    enquiry.enquiryProperties.push({ "key": "pressCard", "value": this.EnquiryData$.controls.pressCard.value });
    enquiry.enquiryProperties.push({ "key": "emailAddress", "value": this.EnquiryData$.controls.emailAddress.value });
    enquiry.enquiryProperties.push({ "key": "cellNumber", "value": this.EnquiryData$.controls.cellNumber.value });
    enquiry.enquiryProperties.push({ "key": "officeNumber", "value": this.EnquiryData$.controls.officeNumber.value });
    enquiry.enquiryProperties.push({ "key": "deadlineDate", "value": this.EnquiryData$.controls.deadlineDate.value });
    enquiry.enquiryProperties.push({ "key": "mediaSubject", "value": this.EnquiryData$.controls.subject.value });
    enquiry.enquiryProperties.push({ "key": "message", "value": this.EnquiryData$.controls.message.value });
    enquiry.enquiryProperties.push({"key": "attachedFile", "value": (this.uploadedFiles != null).toString()});
    enquiry.enquiryProperties.push({ "key": "subject", "value": "Media" });

    this.enquiriesService.saveEnquiry(enquiry).subscribe((response) => {
      var result = response as any;
      this.saveFiles(+result.id);

      this.ResultMessage$ = "Your message has been sent!";

      this.toastService.show('MEDIA ENQUIRY - Your message was successfully sent.', { classname: 'bg-success text-light', delay: 7500, autohide: true });
      this.EnquiryData$.reset();
      //this.EnquiryData$.attachFile.

      Object.keys(this.EnquiryData$.controls).forEach(key => {
        this.EnquiryData$.get(key).setErrors(null);
      });
      //this.EnquiryData$.controls.attachFile.value = '';
      //this.EnquiryData$.controls.attachFile = null;
      $("#lbFileName").text("Choose file");
      this.EnquiryData$.controls.recaptchaReactive = null;

    }, (error) => {
      this.pageErrors = false;
        this.ResultMessage$ = "An error occurred. Please try again later.";
        this.toastService.show('MEDIA ENQUIRY - An error occurred. Please try again later.', { classname: 'bg-danger text-light', delay: 7500, autohide: true });
      console.log(error);
    })
  }

  uploadFile(event) {
    this.uploadedFiles = event.target.files;
    console.log(this.uploadedFiles);
  }

  saveFiles(linkedId: number) {

    if (this.uploadedFiles == null) {
      return;
    }

    this.fileService.upload(this.uploadedFiles, FileSection.MediaEnquiry, FileType.Document, linkedId).subscribe(event => {

    });
  }

  ngOnInit() {
    this.EnquiryData$ = this.formBuilder.group({
      id: [0, Validators.required],
      mediaHouse: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(350)])],
      fullName: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(350)])],
      position: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(350)])],
      pressCard: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(350)])],
      emailAddress: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(350), Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,9}$")])],
      //[Validators.required, Validators.pattern("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?")]
      cellNumber: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(350)])],
      officeNumber: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(350)])],
      deadlineDate: [null, Validators.required],
      subject: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(350)])],
      message: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(350)])],
      attachFile: null,
      recaptchaReactive: null
    });

    //$("#lbFileName").text("Test Choose file");
  }

}
